
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gnn",
      function () {
        return require("private-next-pages/gnn/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gnn"])
      });
    }
  